<template>
  <dv-decoration-2 class="decoration-container" :reverse="reverse" :color="color" :dur="dur"></dv-decoration-2>
</template>
<script>
import { decoration2 } from '@jiaminghi/data-view'
import Vue from 'vue'
import Minin from './mixin'
Vue.use(decoration2)
export default {
  name: 'Decoration2',
  mixins: [Minin]
}
</script>
<style lang="less" scoped>
  .decoration-container{
    width: 100%;
    height: 100%;
  }
</style>